import React from 'react';
import { Flex, Text } from '@mantine/core';
import { useNavigate } from 'react-router';
import { EventPreview } from '../types';
import EventItemContainer from './EventItemContainer';
import { formatDateWithDay } from '@/helpers';
import { EventItemTitle } from './EventItemTitle';

type EventPreviewItemProps = {
  event: EventPreview;
  completed?: boolean;
  calendarItem?: boolean;
  borderColor?: string;
};

const EventItem: React.FC<EventPreviewItemProps> = ({
  event,
  completed,
  calendarItem,
  borderColor,
}) => {
  const navigate = useNavigate();

  return (
    <EventItemContainer
      id={event.productTypeId}
      onClick={() => navigate(event.eventDetailsUrl)}
      calendarItem={calendarItem}
      borderColor={borderColor}
    >
      {completed && (
        <Text size="sm" c="dimmed">
          {formatDateWithDay(event.eventTime)}
        </Text>
      )}
      <EventItemTitle event={event} calendarItem={calendarItem} />
      <Text size="sm">{event.address}</Text>
      {event.setupTime && (
        <Text size="sm">
          Setup Time: {event.setupTime} {' • '} {event.restaurantName}
        </Text>
      )}
      {event.readyAndBaggedTime && (
        <Flex rowGap="0" columnGap="4" wrap="wrap" align="center">
          <Text size="sm">Manifest Time: {event.manifestTime}</Text>
          {' • '}
          <Text size="sm">Ready and Bagged Time: {event.readyAndBaggedTime}</Text>
          {' • '}
          <Text size="sm">{event.restaurantName}</Text>
        </Flex>
      )}
    </EventItemContainer>
  );
};

export default EventItem;
